import { render, staticRenderFns } from "./OverviewProfileContent.vue?vue&type=template&id=2ed8efc9"
import script from "./OverviewProfileContent.vue?vue&type=script&lang=js"
export * from "./OverviewProfileContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports